// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"ProjectsPanel1_outerContainer__1jMk8","slide-in":"ProjectsPanel1_slide-in__2DWmH"};